import { useMemo } from "react";
import useFetch from "./useFetch";
import { useSelector } from "react-redux";

// Define types for Task and TaskGroup
// interface TaskGroup {
//   label: string;
//   type: number;
//   canCreate: boolean;
// }

// interface Task {
//   id: string;
//   title: string;
//   description?: string;
//   dueDate: string;
//   taskGroup: TaskGroup;
//   person: string;
//   finished: boolean;
//   label: string;
//   tasks: any[];
// }

const useTasks = (id?: string) => {
  const personId = useSelector((state: any) => state.user.person_id);
  const userId = id || personId;
  const { data, loading } = useFetch(`task_groups?person.id=${userId}`);
  const tasks = useMemo(() => data?.["hydra:member"] ?? [], [data]);

  return {
    loading,
    tasks,
  };
};

export default useTasks;
